// @flow
import * as React from 'react';
// $$FlowFixMe
import { useContext } from 'react';
import parse from 'date-fns/parse';
import BaseComponent from './UgcAssignment';
import UgcAssignmentContext from './UgcAssignmentContext';

type Props = {
  ugc: Ugc,
  clientId: Id,
  userProfiles?: Array<*>,
};
const EMPTY_RECORD = {};

export default function UgcAssignmentContainer(props: Props) {
  const { assignments, requestAssignment } = useContext(UgcAssignmentContext);
  const { ugc, userProfiles, clientId } = props;
  const assignment = assignments.get(ugc.ugc_id, EMPTY_RECORD);
  const {
    assigned_to: pending_assigned_to,
    assigned_by: pending_assigned_by,
    changeStatus,
  } = assignment;

  const assigned_to =
    pending_assigned_to !== undefined ? pending_assigned_to : ugc.assigned_to;
  const assigned_by =
    pending_assigned_by !== undefined ? pending_assigned_by : ugc.assigned_by;
  const assignedToProfile = Array.isArray(userProfiles)
    ? userProfiles.find(p => p.profile_id === assigned_to)
    : undefined;
  const assignedByProfile = Array.isArray(userProfiles)
    ? userProfiles.find(p => p.profile_id === assigned_by)
    : undefined;
  const assigned_at = ugc.assignment_updated_date
    ? parse(ugc.assignment_updated_date)
    : undefined;

  return (
    <BaseComponent
      options={userProfiles}
      assignedToId={assigned_to}
      assignedToName={assignedToProfile && assignedToProfile.name}
      assignedByName={assignedByProfile && assignedByProfile.name}
      assignedAt={assigned_at}
      onChange={profileId =>
        requestAssignment({
          ugcId: ugc.ugc_id,
          clientId,
          profileId,
        })
      }
      changeStatus={changeStatus}
    />
  );
}



// WEBPACK FOOTER //
// ./src/containers/client/UgcAssignmentContainer.js